module.exports = __webpack_public_path__ + "components/country-flag/static/cu-abcc9415b0c4594cc432d82228be733c.svg";